function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M321.691 333.909l3.684 11.338h11.921l-9.644 7.006 3.684 11.338-9.645-7.007-9.644 7.007 3.684-11.338-9.644-7.006h11.921zm94.937-74.203l3.684 11.338h11.92l-9.644 7.006 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.645-7.006h11.921zm23.788-111.304l3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.007-9.644 7.007 3.684-11.337-9.644-7.007h11.92zm5.893 81.623l3.683 11.338h11.921l-9.643 7.006 3.684 11.337-9.645-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-107.524 77.22l10.623 5.412 8.428-8.429-1.865 11.773 10.622 5.412-11.775 1.865-1.864 11.774-5.412-10.622-11.774 1.866 8.43-8.429zm0-44.522l10.623 5.412 8.428-8.429-1.865 11.774 10.622 5.411-11.775 1.866-1.864 11.773-5.412-10.621-11.774 1.865 8.43-8.429zm37.101 28.539l10.623 5.411 8.429-8.429-1.864 11.774 10.62 5.412-11.775 1.865-1.864 11.774-5.411-10.622-11.774 1.866 8.429-8.429zm0-95.321l10.623 5.411 8.429-8.429-1.864 11.774 10.62 5.412-11.775 1.865-1.864 11.774-5.411-10.622-11.774 1.866 8.429-8.43zm35.958-1.143l10.623 5.411 8.429-8.428-1.865 11.773 10.621 5.412-11.775 1.865-1.864 11.774-5.411-10.622-11.774 1.865 8.429-8.429z",
  fill: "#ffda44"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.333h256v170.663H0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M144 85.33h-32v69.333H0v32h112v69.333h32v-69.333h112v-32H144z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M196.892 200.344L256 233.182v-32.838zm-41.066 0L256 255.996v-15.737l-71.847-39.915zm73.491 55.652l-73.491-40.832v40.832z",
  fill: "#0052b4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M45.171 200.343L0 225.439v-25.096zm55.003 7.078v48.575H12.745z",
  fill: "#0052b4"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M71.846 200.344L0 240.259v15.737l100.174-55.652z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M59.108 140.982L0 108.144v32.838zm41.066 0L0 85.33v15.737l71.847 39.915zM26.683 85.33l73.491 40.832V85.33z",
  fill: "#0052b4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M210.829 140.983L256 115.888v25.095zm-55.003-7.077V85.331h87.429z",
  fill: "#0052b4"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M184.154 140.982L256 101.067V85.33l-100.174 55.652z"
});

const SvgTubalu = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTubalu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tubalu.fa150639.svg";
export { ForwardRef as ReactComponent };